

import { useAuthStore } from '@/stores/authStore';
import apiClient from '@/services/axios';


export const signUpUser = async (formData: any) => {
  const response = await apiClient.post(
    '/users/sign-up',
    {
      firstName: formData.first_name,
      lastName: formData.last_name,
      email: formData.email,
      password: formData.password,
    },
  );
  return response.data;
};


export const signInUser = async (formData: any) => {
  const response = await apiClient.post(
    '/users/sign-in',
    {
      email: formData.email,
      password: formData.password
    },
  );

  return response.data;
};



export const fetchCurrentUser = async () => {
  const authStore = useAuthStore();

  const headers: Record<string, string> = {};

  // added this check because of local development, otherwise login is not possible
  if (import.meta.env.DEV) {
    headers.Bearerization = `Bearer ${authStore.token}`;
  }

  const response = await apiClient.get('/users/me', { headers });

  // Some backends return 200 with empty/anonymous data when the token is missing
  // or invalid (instead of 401). Treat that as unauthorized so callers can
  // trigger a real logout.
  //FIX TO https://elsmartsolutions.atlassian.net/browse/LEC-168
  if (!response.data || !response.data.email || !response.data.userIdentifier) {
    const err: any = new Error('Unauthorized: invalid /users/me response');
    err.response = { status: 401, data: response.data };
    throw err;
  }

  const safeData = Object.fromEntries(
    Object.entries(response.data).map(([key, value]) => {
      if (key === 'roles') {
        if (Array.isArray(value)) {
          return [key, value.map((v) => String(v))];
        }
        if (value && typeof value === 'object') {
          return [key, Object.values(value as Record<string, unknown>).map((v) => String(v))];
        }
        return [key, value == null ? [] : [String(value)]];
      }

      // Only coerce loose scalars to strings here. Booleans (e.g. `orgAdmin`,
      // `tenantOwner`), numbers, arrays and objects (e.g. `tenantMemberships`)
      // must be passed through untouched, otherwise `String(false)` becomes
      // the truthy string `"false"` and breaks any boolean check downstream.
      if (value === null || value === undefined) {
        return [key, value];
      }
      if (typeof value === 'boolean' || typeof value === 'number' || typeof value === 'object') {
        return [key, value];
      }
      return [key, String(value)];
    }),
  );

  return safeData;
};